import { getMonthName } from "./getMonthName";

export function getMonthYearLabel(month: string) {
  return `${getMonthName(parseInt(month.slice(5, 7), 10))} ${month.slice(
    0,
    4
  )}`;
}
